import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import ProductSolution from './ProductSolution';
import PsDropdown from '../UI/PsDropdown';
import * as modalTypes from '../Modals/modalTypes';
import { useHistory } from "react-router-dom";
import { ROUTES } from '../../routes';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { CSSTransition } from 'react-transition-group';


const Projectunit = (props) => {

  const ct = useCustomTranslation();
  const dispatch = useDispatch();
  let history = useHistory();
  const [unitSelected, setUnitSelected] = useState(props.open);

  const showEditProjectunitModalHandler = () => {
    const modalProps = {open: true, formObject: props.unit};
    const modalType = modalTypes.MODAL_EDIT_PROJECTUNIT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showCloneProjectunitModalHandler = () => {
    const modalProps = {open: true, formObject: props.unit};
    const modalType = modalTypes.MODAL_CLONE_PROJECTUNIT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showDeleteProjectunitModalHandler = () => {
    const modalProps = {open: true, projectunit: props.unit};
    const modalType = modalTypes.MODAL_DELETE_PROJECTUNIT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }


  const addProductSolutionHandler = () => {
    dispatch( actions.wizardReset() ).then(
      dispatch ( actions.wizardSetProjectScope(props.project.id) )).then(
        dispatch ( actions.wizardSetProjectunitScope(props.unit.id) )).then(
        history.push(ROUTES.TO_WIZARD) )
  }

  // Selected Units
  const toggleUnitSelected = () => {
    setUnitSelected(!unitSelected);
  }


  const thisProductSolutions = useSelector(state => {
    return (projectunit) => actions.getInventoryObjects(state, 'productSolutions', projectunit.product_solutions)
  });

  const solutionCount = (props.unit.product_solutions !== undefined && props.unit.product_solutions.length !== 0 )? props.unit.product_solutions.length : 0
  const solutionCountMarker = (solutionCount === 0 )? ct('projectunit.marker.no_solution') : solutionCount

  const solutionItemsCount = (solution) =>  (solution.product_solution_items !== undefined)? solution.product_solution_items.reduce((total, num) => total + num['amount'], 0) : 0
  const solutionItems = (solution) => {
    return (solution.product_solution_items !== undefined)? solution.product_solution_items : []
  }

  const dropDownItems = [
    {action: showEditProjectunitModalHandler, text: ct('projectunit.dropdown.edit_projectunit'), id: props.unit.id + "edit" },
    {action: addProductSolutionHandler, text: ct('projectunit.dropdown.add_solution'), id: props.unit.id + "add_solution" },
    {action: showCloneProjectunitModalHandler, text: ct('projectunit.dropdown.copy_projectunit'), id: props.unit.id + "clone" },
    {action: showDeleteProjectunitModalHandler, text: ct('projectunit.dropdown.delete_projectunit'), id: props.unit.id + "delete" },
  ]

  const dropDownIcon = () => {
    if (solutionCount !== 0) {
      return " ▼" //<i className="material-icons" style={{fontSize: "90%"}}>arrow_downward</i>
    } else {
      return null
    }
  }

  const cssClassCardBody = {
    border: "0px",
  }

  const cssClassCardFooter = {
    border: "0px",
    padding: "0px",
    height: "1.2em",
    fontSize: "130%",
  }

  const cardClass = () => {
    return (solutionCount === 0)? "card projectunit-empty" : "card projectunit"
  }

  return (
    <Aux>
      <div className={cardClass()} onClick={toggleUnitSelected}>
        <div className={"card-body"} style={cssClassCardBody}>
          <div className="card-title">
            <h6>{props.unit.title}<span className="badge badge-light align-top" style={{background: "#dee2e6", marginLeft: "5px"}}>{solutionCountMarker}{dropDownIcon()}</span></h6>
            <span className="text-small">{props.unit.description}</span>
          </div>
          <div className="dropdown card-options">
            <PsDropdown items={dropDownItems} />
          </div>
        </div>
        {(solutionCount !== 0) && (
          <div className="text-center" style={cssClassCardFooter}>
            {unitSelected ? <i className="material-icons">expand_less</i> : <i className="material-icons">expand_more</i>}
          </div>
        )}
      </div>

      <CSSTransition
        in={unitSelected}
        timeout={300}
        classNames="solution-slide"
        unmountOnExit
        mountOnEnter
      >
        <div className="solution-wrapper" style={{ 
          marginBottom: unitSelected ? '1rem' : '0',
          overflow: 'visible'
        }}>
          {thisProductSolutions(props.unit).map(x => (
            <ProductSolution
              key={x.id}
              projectId={props.project.id}
              token={x.token}
              wizardConfiguration={{
                country: x.country,
                fwk: x.fwk,
                location: x.installation_location,
                executionType: x.execution_type,
                mediumTypes: x.medium_types,
                productSystem: x.product_system
              }}
              amount={x.amount}
              description={x.description}
              notice={x.notice}
              hole_form={x.hole_form}
              hole_width={x.hole_width}
              hole_height={x.hole_height}
              hole_diameter={x.hole_diameter}
              calculation_schottbelegung_success={x.calculation_schottbelegung_success}
              calculation_schottbelegung_coverage={x.calculation_schottbelegung_coverage}
              calculation_schottbelegung_status={x.calculation_schottbelegung_status}
              productSolutionId={x.id}
              solutionItems={solutionItems(x)}
              productSystemId={x.product_system}
              itemsCount={solutionItemsCount(x)}
            />
          ))}
        </div>
      </CSSTransition>
    </Aux>
  )
}

export default Projectunit;



// WEBPACK FOOTER //
// ./src/components/Project/Projectunit.js